import {
  faBook,
  faGlobe,
  faMusic,
  faShieldAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb } from "../components/ui";
import { UserAuth } from "../context/AuthContext";

// Data sources for name generation
const DATA_SOURCES = [
  {
    category: "Word & Language",
    icon: faGlobe,
    sources: [
      { name: "Datamuse", description: "Rhymes, associations, phonetics" },
      { name: "ReverseDictionary", description: "Semantic word relationships" },
      { name: "Wikipedia", description: "Knowledge extraction" },
      { name: "PullPush Reddit", description: "Linguistic analysis" },
    ],
  },
  {
    category: "Literary",
    icon: faBook,
    sources: [
      { name: "Project Gutenberg", description: "Public domain texts" },
      { name: "Open Library", description: "Book metadata" },
      { name: "WikiSource", description: "Literary content" },
      { name: "Standard Ebooks", description: "Public domain ebooks" },
    ],
  },
  {
    category: "Media",
    icon: faMusic,
    sources: [
      { name: "Spotify", description: "Playlist-based inspiration" },
    ],
  },
  {
    category: "Trademark",
    icon: faShieldAlt,
    sources: [
      { name: "TMView", description: "Global trademark search" },
    ],
  },
];

const SourceCard = ({ source }) => (
  <div className="bg-base-100 rounded-lg p-3 border border-base-content/10">
    <span className="font-medium text-sm text-base-content">{source.name}</span>
    <p className="text-[10px] text-base-content/50 mt-1">{source.description}</p>
  </div>
);

const CategorySection = ({ category, icon, sources }) => (
  <div className="mb-6">
    <div className="flex items-center gap-2 mb-3">
      <FontAwesomeIcon icon={icon} className="text-base-content/40 text-sm" />
      <h2 className="text-sm font-medium text-base-content/60">{category}</h2>
      <span className="text-[10px] text-base-content/30">({sources.length})</span>
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2">
      {sources.map(source => (
        <SourceCard key={source.name} source={source} />
      ))}
    </div>
  </div>
);

function AdminDataSources() {
  const { user } = UserAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user === null) {
      navigate("/signin");
    }
  }, [user, navigate]);

  if (!user?.email) {
    return null;
  }

  const totalSources = DATA_SOURCES.reduce((sum, cat) => sum + cat.sources.length, 0);

  return (
    <div className="container mx-auto px-4 py-6">
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Admin", href: "/admin" },
          { label: "Data Sources" },
        ]}
        className="mb-4"
      />

      <p className="text-xs text-base-content/40 mb-6">
        {totalSources} external sources used for name generation
      </p>

      {DATA_SOURCES.map(({ category, icon, sources }) => (
        <CategorySection key={category} category={category} icon={icon} sources={sources} />
      ))}
    </div>
  );
}

export default AdminDataSources;
